var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isSettings)?_c('MainPage',{on:{"open-settings":_vm.openSettings}}):_c('SettingsPage',{on:{"accept-policies":_vm.acceptPolicies,"reject-policies":_vm.rejectPolicies,"save-custom-settings":_vm.saveSettings}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d0dbca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gdpr/layout/DisclaimerBody.vue
// module id = null
// module chunks = 